import { logWithMerchantToken } from '@lib/api/v2';

/** V2 회원 방문 로그 조회 */
export const getUserLogV2 = (params: UserLogParams) =>
  logWithMerchantToken.get<UserLogResponse>('/user', { params });

/** V2 입퇴장 로그 조회 */
export const getEntryExitLogV2 = (params: EntryExitLogParams) =>
  logWithMerchantToken.get<EntryExitLogResponse>('/entry-exit', { params });
